import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="3f25ah0bk0cik">
      {kicker && <p className={`font-display text-base font-semibold uppercase tracking-wide ${dark ? "text-sun" : "text-teal"}`} data-id="element-64" data-mp="3jznbm4jbxng0">{kicker}</p>}
      <h2 className={`mt-2 font-display text-[2rem] font-bold leading-[1.1] sm:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-65" data-mp="bkvimtn7aqxk">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? "text-white/85" : "text-ink-soft"}`} data-id="element-66" data-mp="1tit48ovkcup">{subtitle}</p>}
    </div>;
}